import { MapPin, RotateCcw, SlidersHorizontal } from "lucide-react";

/** Minimal utilities beside text-only browsing tabs. */
const CHIP = "inline-flex shrink-0 items-center justify-center gap-1.5 rounded-md whitespace-nowrap text-[11px] font-bold transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E30613]";
const TONE = {
  light: "text-[#575650] hover:bg-black/[0.045] hover:text-[#111]",
  dark: "text-white/70 hover:bg-white/10 hover:text-white",
};
const ACTIVE = "bg-[#E30613]/[0.08] text-[#bf171e] dark:text-[#ff9b97]";

export default function CategoryActions({
  compact = false,
  isDark,
  lang,
  hasFilter,
  onOpenFilters,
  onNearMe,
  onClear,
  className = ""
}) {
  const tone = isDark ? TONE.dark : TONE.light;
  const size = compact ? "h-10 w-10" : "h-10 px-2 sm:min-w-[68px]";
  const label = (es, en) => lang === "es" ? es : en;

  return (
    <div className={className}>
      <button
        type="button"
        onClick={onOpenFilters}
        aria-label={label("Búsqueda avanzada y filtros", "Advanced search and filters")}
        aria-pressed={!!hasFilter}
        title={label("Filtros", "Filters")}
        className={`${CHIP} ${size} ${hasFilter ? ACTIVE : tone}`}
      >
        <SlidersHorizontal aria-hidden="true" className="h-[17px] w-[17px] shrink-0" strokeWidth={1.8} />
        {!compact && <span>{label("Filtros", "Filters")}</span>}
      </button>
      <button
        type="button"
        onClick={onNearMe}
        aria-label={label("Abrir mapa con lugares cercanos", "Open map of nearby places")}
        title={label("Mapa", "Map")}
        className={`${CHIP} ${size} ${tone}`}
      >
        <MapPin aria-hidden="true" className="h-[17px] w-[17px] shrink-0" strokeWidth={1.8} />
        {!compact && <span>{label("Mapa", "Map")}</span>}
      </button>
      {hasFilter && (
        <button
          type="button"
          onClick={onClear}
          aria-label={label("Limpiar los filtros", "Clear filters")}
          title={label("Limpiar", "Clear")}
          className={`${CHIP} ${size} ${tone}`}
        >
          <RotateCcw aria-hidden="true" className="h-[16px] w-[16px] shrink-0" strokeWidth={1.8} />
          {!compact && <span>{label("Limpiar", "Clear")}</span>}
        </button>
      )}
    </div>
  );
}
